/**
 * get locale object (short and full locale name)
 * @param  {String} locale locale string
 * @return {Object}        locale object
 */
const getLocaleObject = (locale: string) => {
  const splitLocale = locale.split('-');
  let fullLocale = splitLocale[0];

  if (splitLocale.length > 1) {
    const primaryName = splitLocale[0].toLowerCase();
    let secondaryName = splitLocale[1];
    // special case to handle zh-Hant and zh-Hans
    // (the full lang code should be zh-Hant-TW and zh-Hans-CN, but we are serving zh-Hant and zh-Hans now)
    // https://github.com/yahoo/intl-relativeformat/blob/master/dist/locale-data/zh.js
    if (primaryName.toLowerCase() === 'zh') {
      secondaryName = secondaryName.charAt(0).toUpperCase() + secondaryName.slice(1).toLowerCase();
    } else {
      secondaryName = secondaryName.toUpperCase();
    }
    fullLocale = [primaryName, secondaryName].join('-');
  }

  return {
    shortLocale: splitLocale[0],
    fullLocale,
  };
};

export default getLocaleObject;
